"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SymbolProviderBase = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const constants_1 = require("./constants");
class SymbolProviderBase {
    constructor(_cacheKey) {
        this.subject = new rxjs_1.BehaviorSubject(constants_1.EmptyExchangeSymbolDataItem);
        this.cacheKey = _cacheKey;
    }
    init() {
        return this.initWithCache();
    }
    register() {
        return (0, rxjs_1.timer)(0, 5 * 60 * 1000).pipe((0, operators_1.exhaustMap)(() => {
            return this.updateAndCache();
        }));
    }
}
exports.SymbolProviderBase = SymbolProviderBase;
